import React, {useEffect} from 'react';
import styled from "styled-components";
import ButtonTransparent from "@atoms/button.transparent";
import NavBarAccount from "./account";
import PropertyCreateButton, {PropertyCreate} from "./property.create.button";
import NavBarItems, {Items, DropdownUl} from "./items";
import CloseIcon from '@icons/close.svg';
import Icon from "@atoms/icon";
import {handleLockBrowserScroll} from "@helpers/helpers";

var drawerOpened = false;
export default function NavBarDrawer(props) {

    useEffect(() => {
        const bodyClasses = document.body.classList;

        if (props.show) {
            drawerOpened = true;
            bodyClasses.add('menu-open');
            handleLockBrowserScroll(true);

            window.history.pushState(null, "", window.location.href);

            window.onpopstate = () => {
                window.history.pushState('back', null, null);

                if (props.show) {
                    props.setNavbarToggle(false);
                }
            };
        } else {
            setTimeout(() => {
                bodyClasses.remove('menu-open');
                bodyClasses.remove('modal-open');
            }, 400);

            const checkBodyClasses = (!bodyClasses.contains('selection-open') &&
                !bodyClasses.contains('filter-open') &&
                !bodyClasses.contains('swiper-open'));

            if (checkBodyClasses) {
                handleLockBrowserScroll(false);
            }

            /*if (!isEmpty(window.onpopstate) && drawerOpened) {
                drawerOpened = false;
                window.onpopstate = undefined;
                window.history.back();
            }*/
        }
    }, [props.show]);


    return (
        <Drawer className={"d-lg-none " + (props.show ? 'show' : '')}>
            <DrawerBody>
                <Header className="navbar-collapse-header d-lg-none mb-48">
                    <ButtonTransparent onClick={() => props.setNavbarToggle(false)} className="d-block p-0 d-md-hidden navbar-toggle hidden-navbar-toggle line-height-0">
                        <Icon className="drawer-close"><CloseIcon width="24"/></Icon>
                    </ButtonTransparent>
                </Header>

                <NavBarAccount drawerShow={props.show} setLoginShow={props.setLoginShow}/>

                <PropertyCreateButton id="btnRegister2"/>

                <NavBarItems
                    inPage={props.inPage}
                    isBadeSaba={props.isBadeSaba}
                    navbarItemsLinks={props.navbarItemsLinks}
                    setNavbarToggle={props.setNavbarToggle}/>
            </DrawerBody>
        </Drawer>
    )
}

// styles

const DrawerBody = styled.div`
    overflow-y: auto;
    padding: 24px;
    width: 100%;
    height: 100% !important;
    max-height: 100% !important;
    display: block;
    position: static;
`;

const Drawer = styled.div`
    display: block;
    position: fixed !important;
    top: 100%;
    opacity: 0;
    right: 0;
    width: 100%;
    height: 100vh !important;
    max-height: 100vh !important;
    transition: top 0.4s cubic-bezier(0.175, 0.885, 0.35, 1), opacity 0.1s linear;
    background: ${props => props.theme.white};
    margin: 0;
    z-index: 49;
    
    &.show {
        top: 0;
        opacity: 1;
    }
    
    ${PropertyCreate} {
        padding:0;

        a {
            height: 62px;
            width: 100%;
            display: flex;
            flex-flow: row;
            justify-content: space-between;
            align-items: center;
            border: 0;
            border-top: 1px solid ${props => props.theme.gray200} !important;
            border-bottom: 1px solid ${props => props.theme.gray200} !important;
            border-radius: 0;
            padding: 0;
            background-color: transparent;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.69;
            color: ${props => props.theme.black};
            
            svg {
                margin-left: 0;
                path {
                    stroke: ${props => props.theme.black} !important;
                }
            }
            
            .icons {
                margin-left: 16px;
            }
            
            .left-caret-icons {
                margin-left: 0;
                display: block !important;
                
                svg {
                    path {
                        stroke-width: 1;
                    }
                }
            }
            
            &:hover, &:focus, &:active {
                color: ${props => props.theme.black} !important;
                background-color: transparent !important;
                box-shadow: none !important;
                
                svg {
                    margin-left: 0;
                    path {
                        stroke: ${props => props.theme.black} !important;
                    }
                }
            }
        }
    }
    
    ${Items} {
        flex-direction: column;
        
        &:last-child {
            border-bottom: none;
        }
        
        &:first-child {
            padding-top: 0;
        }
        
        li {
            display: flex;
            align-items: center;
            width: 100%;
            padding: 16px 0;
            margin: 0;
            border-bottom: 1px solid ${props => props.theme.gray200};
            
            a,button {
                width: 100%;
                display: flex;
                align-items: center;
                
                .icons {
                    margin-left: 16px;
                    
                    &.left-icons {
                        display: block;
                        margin-left: 0;
                    }
                }
            }
            
            &.logout {
                button {
                    width: 100%;
                    padding: 0;
                    font-weight: 400;
                }
            }
        }
        
        ${DropdownUl} {
            li {
                border-bottom: 0;
            }
        }
    }
`;

const Header = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;

    &::before,
    &::after {
        display: none;
    }
    
    .drawer-close {
        width: 16px;
    }
`;